import React from 'react';

const CorpAccountIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C8.89543 2 8 2.89543 8 4H12C12 2.89543 11.1046 2 10 2ZM10 0C7.79086 0 6 1.79086 6 4H3C1.34315 4 0 5.34315 0 7V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V12V7C20 5.34315 18.6569 4 17 4H14C14 1.79086 12.2091 0 10 0ZM18 11V7C18 6.44771 17.5523 6 17 6H3C2.44772 6 2 6.44772 2 7V11H6V10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10V11H18ZM14 13H18V17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17V13H6V14C6 14.5523 6.44772 15 7 15H13C13.5523 15 14 14.5523 14 14V13ZM12 12V11H8V12V13H12V12Z"
      fill="#4D4D4D"
    />
  </svg>
);

export default CorpAccountIcon;
